export default __webpack_public_path__ + "static/download-app-phone-1-9a629ef238ab806c786a33d4f527b0bc.png";